/**
 * Access Requests (Autorizações Ops) — service dedicado.
 *
 * Centraliza as chamadas antes espalhadas inline nas páginas de Autorizações
 * e Comercial, e adiciona o provisionamento P2 (preview → provision).
 *
 * Regra de ouro do provisionamento: o frontend COLETA INTENÇÃO; o backend
 * /preview determina exatamente os efeitos; o frontend EXIBE o plano
 * retornado; /provision executa. O React nunca decide sozinho se cria
 * user_role/User_Institutions/invite.
 *
 * Auth: X-Ops-Api-Key + X-Ops-User-Email injetados globalmente pelo
 * interceptor de api.js.
 */
import { AZURE } from './api';

const BASE = '/governance/commercial/access-requests';

/** Lista access requests (opcional: { status, limit }). */
export const listAccessRequests = async (params = {}) => {
  const { data } = await AZURE.get(BASE, { params });
  return data?.data || [];
};

/** Summary por status (fila). */
export const getAccessRequestsSummary = async () => {
  const { data } = await AZURE.get(`${BASE}/summary`);
  return data?.data || {};
};

/** Detalhe (request + activity). */
export const getAccessRequest = async (requestId) => {
  const { data } = await AZURE.get(`${BASE}/${requestId}`);
  return data?.data || null;
};

/** Transição de status (máquina P1.4 — CONVERTED é reservado ao provision). */
export const patchAccessRequestStatus = async (requestId, status, note) => {
  const { data } = await AZURE.patch(`${BASE}/${requestId}/status`, { status, note });
  return data;
};

/**
 * Preview do provisionamento (dry-run — ZERO write).
 * payload: { institution_mode: 'existing'|'new', institution_id?,
 *            responsible_mode: 'keep_existing'|'existing_user'|'invite',
 *            responsible_user_id?, responsible_email?, responsible_name? }
 * Retorna o plano { writes, no_changes, institution, responsible } ou
 * snapshot { already_converted: true, ... } se o request já foi convertido.
 */
export const previewProvision = async (requestId, payload) => {
  const { data } = await AZURE.post(`${BASE}/${requestId}/provision/preview`, payload);
  return data?.data ?? data;
};

/** Provisionamento real (APPROVED → CONVERTED). Idempotente no backend. */
export const provisionAccessRequest = async (requestId, payload) => {
  const { data } = await AZURE.post(`${BASE}/${requestId}/provision`, payload);
  return data?.data ?? data;
};

// ── Lookup founder-only de Institutions (NÃO usa o endpoint público) ────────

/** Busca server-side de instituições (founder-only, limitada). */
export const searchInstitutions = async (q = '', limit = 20) => {
  const { data } = await AZURE.get('/governance/institutions', { params: { q, limit } });
  return data?.data || [];
};

/**
 * Contexto de provisionamento de uma institution:
 * { institution: {...}, active_gestores: [{user_id, name, email}] }.
 * É o que habilita/desabilita keep_existing na UI (o backend revalida).
 */
export const getProvisioningContext = async (institutionId) => {
  const { data } = await AZURE.get(`/governance/institutions/${institutionId}/provisioning-context`);
  return data?.data || null;
};
